import * as CONST from '../ActionTypes';

const initialState = {
  productList: [],
  product: {},
  stocksInWarehouses: [],
  warehouse: {},
  expirations: {},
  stockHistories: {},
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
};

function product(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 商品一覧取得
    // -----------------
    case CONST.GET_PRODUCT_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          productList: action.payload,
        },
      );
    case CONST.GET_PRODUCT_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          productList: [],
        },
      );
    // -----------------
    // 商品詳細取得
    // -----------------
    case CONST.GET_PRODUCT_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          product: action.payload,
        },
      );
    case CONST.GET_PRODUCT_DETAIL_FAILURE:
      return Object.assign(
        {},
        state,
        {
          product: {},
        },
      );
    // -----------------
    // 商品削除
    // -----------------
    case CONST.DELETE_PRODUCT_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.DELETE_PRODUCT_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_DELETE_PRODUCT_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    // 在庫管理
    case CONST.GET_PRODUCT_STOCK_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          stocksInWarehouses: action.payload,
        },
      );
    case CONST.GET_PRODUCT_STOCK_FAILURE:
      return Object.assign(
        {},
        state,
        {
          stocksInWarehouses: {},
          errorMessage: action.payload,
        },
      );
    case CONST.GET_PRODUCT_STOCK_HISTORY_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          stockHistories: action.payload,
        },
      );
    case CONST.GET_PRODUCT_STOCK_HISTORY_FAILURE:
      return Object.assign(
        {},
        state,
        {
          stockHistories: {},
          errorMessage: action.payload,
        },
      );
    case CONST.CREATE_PRODUCT_STOCK_HISTORY_SUCCESS:
      return Object.assign(
        {},
        state,
      );
    case CONST.CREATE_PRODUCT_STOCK_HISTORY_FAILURE:
      return Object.assign(
        {},
        state,
        {
          errorMessage: action.payload,
        },
      );
    case CONST.GET_PRODUCT_STOCK_IN_WAREHOUSE_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          warehouse: action.payload,
        },
      );
    case CONST.GET_PRODUCT_STOCK_IN_WAREHOUSE_FAILURE:
      return Object.assign(
        {},
        state,
        {
          warehouse: {},
          errorMessage: action.payload,
        },
      );
    case CONST.GET_PRODUCT_EXPIRATION_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          expirations: action.payload,
        },
      );
    case CONST.GET_PRODUCT_EXPIRATION_FAILURE:
      return Object.assign(
        {},
        state,
        {
          expirations: {},
          errorMessage: action.payload,
        },
      );
    case CONST.CREATE_PRODUCT_EXPIRATION_SUCCESS:
      return Object.assign(
        {},
        state,
      );
    case CONST.CREATE_PRODUCT_EXPIRATION_FAILURE:
      return Object.assign(
        {},
        state,
        {
          errorMessage: action.payload,
        },
      );
    case CONST.UPDATE_PRODUCT_EXPIRATION_SUCCESS:
      return Object.assign(
        {},
        state,
      );
    case CONST.UPDATE_PRODUCT_EXPIRATION_FAILURE:
      return Object.assign(
        {},
        state,
        {
          errorMessage: action.payload,
        },
      );
    default:
      return state;
  }
}

export default product;
